<div class="empty-shell">
    <nb-icon icon="file-1" pack="engin" status="basic"></nb-icon>
    <span *ngIf="rowData" class="empty-shell-text">{{ rowData }}</span>
    <span *ngIf="!rowData" class="empty-shell-text">No Data found</span>
</div>
